

// // import React, { useState, useEffect } from "react";
// // // import axios from "axios";

// // import axios from "../api/axiosAuth";
// // import { useAuth } from "../context/AuthContext";
// // import "../style/GestionContenido.css";

// // const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api";

// // export default function ContenidosProfesor() {
// //   const { user, token } = useAuth();

// //   const [asignaciones, setAsignaciones] = useState([]);
// //   const [contenidos, setContenidos] = useState([]);
// //   const [periodos, setPeriodos] = useState([]);

// //   // 🔥 NUEVO
// //   const [periodoActivo, setPeriodoActivo] = useState(null);

// //   const [titulo, setTitulo] = useState("");
// //   const [descripcion, setDescripcion] = useState("");
// //   const [tipo, setTipo] = useState("archivo");
// //   const [enlace, setEnlace] = useState("");
// //   const [archivo, setArchivo] = useState(null);
// //   const [asignacionId, setAsignacionId] = useState("");

// //   // filtros tabla
// //   const [periodoId, setPeriodoId] = useState("");
// //   const [anioLectivo, setAnioLectivo] = useState("");

// //   // 🔥 edición
// //   const [editandoId, setEditandoId] = useState(null);
// //   const [editTitulo, setEditTitulo] = useState("");
// //   const [editDescripcion, setEditDescripcion] = useState("");

// //   const [mensaje, setMensaje] = useState("");

// //   const api = axios.create({
// //     baseURL: API,
// //     headers: { Authorization: `Bearer ${token}` },
// //     withCredentials: true
// //   });

// //   /* =============================
// //      CARGAS INICIALES
// //   ============================== */
// //   useEffect(() => {
// //     if (!user) return;

// //     api.get(`/contenidos/asignaciones-profesor/${user.id}`)
// //       .then(r => setAsignaciones(r.data || []))
// //       .catch(() => setAsignaciones([]));

// //     api.get("/contenidos/periodos")
// //       .then(r => setPeriodos(r.data || []))
// //       .catch(() => setPeriodos([]));

// //     // 🔥 periodo activo
// //     api.get("/contenidos/periodo-activo")
// //       .then(r => setPeriodoActivo(r.data))
// //       .catch(() => setPeriodoActivo(null));

// //     cargarContenidos();
// //   }, [user]);

// //   /* =============================
// //      CONTENIDOS
// //   ============================== */
// //   const cargarContenidos = async () => {
// //     const res = await api.get("/contenidos/mis-contenidos", {
// //       params: {
// //         periodo_id: periodoId || undefined,
// //         anio_lectivo: anioLectivo || undefined
// //       }
// //     });
// //     setContenidos(res.data || []);
// //   };

// //   useEffect(() => {
// //     cargarContenidos();
// //   }, [periodoId, anioLectivo]);

// //   /* =============================
// //      SUBIR CONTENIDO
// //   ============================== */
// //   const handleSubmit = async (e) => {
// //     e.preventDefault();
// //     setMensaje("");

// //     if (!asignacionId) {
// //       setMensaje("❌ Debes seleccionar una asignación");
// //       return;
// //     }

// //     if (!titulo.trim()) {
// //       setMensaje("❌ El título es obligatorio");
// //       return;
// //     }

// //     const fd = new FormData();
// //     fd.append("titulo", titulo);
// //     fd.append("descripcion", descripcion);
// //     fd.append("tipo", tipo);
// //     fd.append("asignacion_id", asignacionId);

// //     if (tipo === "archivo") {
// //       if (!archivo) return setMensaje("❌ Selecciona un archivo");
// //       fd.append("archivo", archivo);
// //     } else {
// //       if (!enlace.trim()) return setMensaje("❌ Ingresa un enlace");
// //       fd.append("enlace", enlace);
// //     }

// //     await api.post("/contenidos/subir", fd, {
// //       headers: { "Content-Type": "multipart/form-data" }
// //     });

// //     setMensaje("✅ Guía enviada correctamente");

// //     setTitulo("");
// //     setDescripcion("");
// //     setTipo("archivo");
// //     setEnlace("");
// //     setArchivo(null);
// //     setAsignacionId("");

// //     cargarContenidos();
// //   };

// //   /* =============================
// //      🗑️ ELIMINAR
// //   ============================== */
// //   const eliminarGuia = async (id) => {
// //     if (!window.confirm("¿Eliminar esta guía?")) return;
// //     await api.delete(`/contenidos/${id}`);
// //     cargarContenidos();
// //   };

// //   /* =============================
// //      ✏️ EDITAR
// //   ============================== */
// //   const iniciarEdicion = (c) => {
// //     setEditandoId(c.id);
// //     setEditTitulo(c.titulo);
// //     setEditDescripcion(c.descripcion || "");
// //   };

// //   const guardarEdicion = async (id) => {
// //     await api.put(`/contenidos/${id}`, {
// //       titulo: editTitulo,
// //       descripcion: editDescripcion
// //     });
// //     setEditandoId(null);
// //     cargarContenidos();
// //   };

// //   /* =============================
// //      📊 EXPORTAR EXCEL
// //   ============================== */
// //   const exportarExcel = () => {
// //     window.open(`${API}/contenidos/exportar/excel`, "_blank");
// //   };

// //   return (
// //     <div className="contenidos-container">

// //       {/* 🔥 PERIODO ACTIVO */}
// //       {periodoActivo && (
// //         <div className="periodo-activo">
// //           📌 <strong>Período activo:</strong> {periodoActivo.periodo} – {periodoActivo.anio}
// //         </div>
// //       )}

// //       <h2>📚 Subir Contenido</h2>

// //       <form onSubmit={handleSubmit} className="formulario">
// //         <input
// //           placeholder="Título"
// //           value={titulo}
// //           onChange={e => setTitulo(e.target.value)}
// //         />

// //         <textarea
// //           placeholder="Descripción"
// //           value={descripcion}
// //           onChange={e => setDescripcion(e.target.value)}
// //         />

// //         <select value={tipo} onChange={e => setTipo(e.target.value)}>
// //           <option value="archivo">Archivo</option>
// //           <option value="enlace">Enlace</option>
// //           <option value="video">Video</option>
// //         </select>

// //         {tipo === "archivo" ? (
// //           <input type="file" onChange={e => setArchivo(e.target.files[0])} />
// //         ) : (
// //           <input
// //             placeholder="Enlace"
// //             value={enlace}
// //             onChange={e => setEnlace(e.target.value)}
// //           />
// //         )}

// //         <select
// //           value={asignacionId}
// //           onChange={e => setAsignacionId(e.target.value)}
// //         >
// //           <option value="">-- Selecciona asignación --</option>
// //           {asignaciones.map(a => (
// //             <option key={a.asignacion_id} value={a.asignacion_id}>
// //               {a.materia_nombre} – {a.grado}°{a.grupo}
// //             </option>
// //           ))}
// //         </select>

// //         <button type="submit">Guardar</button>
// //       </form>

// //       {mensaje && <p className="mensaje">{mensaje}</p>}

// //       <h2>📂 Mis Guías</h2>

// //       <div className="filtros">
// //         <select onChange={e => setPeriodoId(e.target.value)}>
// //           <option value="">Todos los periodos</option>
// //           {periodos.map(p => (
// //             <option key={p.id} value={p.id}>{p.nombre}</option>
// //           ))}
// //         </select>

// //         <button onClick={exportarExcel}>📊 Exportar Excel</button>
// //       </div>

// //       <table className="tabla">
// //         <thead>
// //           <tr>
// //             <th>Materia</th>
// //             <th>Grado</th>
// //             <th>Título</th>
// //             <th>Periodo</th>
// //             <th>Año</th>
// //             <th>Acciones</th>
// //           </tr>
// //         </thead>
// //         <tbody>
// //           {contenidos.map(c => (
// //             <tr key={c.id}>
// //               <td>{c.materia}</td>
// //               <td>{c.grado}°{c.grupo}</td>

// //               <td>
// //                 {editandoId === c.id ? (
// //                   <input
// //                     value={editTitulo}
// //                     onChange={e => setEditTitulo(e.target.value)}
// //                   />
// //                 ) : (
// //                   c.titulo
// //                 )}
// //               </td>

// //               <td>{c.periodo}</td>
// //               <td>{c.anio_lectivo}</td>

// //               <td>
// //                 {editandoId === c.id ? (
// //                   <>
// //                     <button onClick={() => guardarEdicion(c.id)}>💾</button>
// //                     <button onClick={() => setEditandoId(null)}>❌</button>
// //                   </>
// //                 ) : (
// //                   <>
// //                     <button onClick={() => iniciarEdicion(c)}>✏️</button>
// //                     <button onClick={() => eliminarGuia(c.id)}>🗑️</button>
// //                   </>
// //                 )}
// //               </td>
// //             </tr>
// //           ))}
// //         </tbody>
// //       </table>
// //     </div>
// //   );
// // }


// //
// import React, { useState, useEffect, useMemo, useCallback } from "react";
// import axios from "axios";
// import { useAuth } from "../context/AuthContext";
// import { API as BASE_API } from "../components/config";
// import "../style/GestionContenido.css";

// const API_URL = BASE_API; // 🔥 YA INCLUYE /api

// export default function ContenidosProfesor() {
//   const { user, token } = useAuth();

//   const [asignaciones, setAsignaciones] = useState([]);
//   const [contenidos, setContenidos] = useState([]);
//   const [periodos, setPeriodos] = useState([]);
//   const [periodoActivo, setPeriodoActivo] = useState(null);

//   const [titulo, setTitulo] = useState("");
//   const [descripcion, setDescripcion] = useState("");
//   const [tipo, setTipo] = useState("archivo");
//   const [enlace, setEnlace] = useState("");
//   const [archivo, setArchivo] = useState(null);
//   const [asignacionId, setAsignacionId] = useState("");

//   const [periodoId, setPeriodoId] = useState("");
//   const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });

//   /* ================= AXIOS INSTANCE ================= */
//   const api = useMemo(
//     () =>
//       axios.create({
//         baseURL: API_URL,
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//         withCredentials: true,
//       }),
//     [token]
//   );

//   /* ================= CARGAR CONTENIDOS ================= */
//   const cargarContenidos = useCallback(async () => {
//     try {
//       const res = await api.get("/contenidos/mis-contenidos", {
//         params: {
//           periodo_id: periodoId || undefined,
//         },
//       });

//       setContenidos(res.data || []);
//     } catch (err) {
//       console.error("Error contenidos:", err);
//       setContenidos([]);
//     }
//   }, [api, periodoId]);

//   /* ================= INIT ================= */
//   // useEffect(() => {
//   //   if (!user || !token) return;

//   //   const init = async () => {
//   //     try {
//   //       const [asig, per, activo] = await Promise.all([
//   //         api.get(`/contenidos/asignaciones-profesor/${user.id}`),
//   //         api.get(`/contenidos/periodos`),
//   //         api.get(`/contenidos/periodo-activo`),
//   //       ]);

//   //       setAsignaciones(asig.data || []);
//   //       setPeriodos(per.data || []);
//   //       setPeriodoActivo(activo.data || null);
//   //     } catch (err) {
//   //       console.error("INIT ERROR:", err);
//   //     }
//   //   };

//   //   init();
//   // }, [user, token, api]);

// /* ================= INIT ================= */
// useEffect(() => {
//   if (!user || !token) return;

//   const init = async () => {
//     try {
//       const [asigRes, perRes, activoRes] = await Promise.all([
//         api.get(`/contenidos/asignaciones-profesor/${user.id}`),
//         api.get(`/contenidos/periodos`),
//         api.get(`/contenidos/periodo-activo`),
//       ]);

//       /* ===============================
//          ASIGNACIONES
//       =============================== */
//       let asignacionesData = [];

//       if (Array.isArray(asigRes.data)) {
//         asignacionesData = asigRes.data;
//       } else if (
//         asigRes.data &&
//         Array.isArray(asigRes.data.asignaciones)
//       ) {
//         asignacionesData = asigRes.data.asignaciones;
//       }

//       setAsignaciones(asignacionesData);

//       /* ===============================
//          PERIODOS
//       =============================== */
//       let periodosData = [];

//       if (Array.isArray(perRes.data)) {
//         periodosData = perRes.data;
//       } else if (
//         perRes.data &&
//         Array.isArray(perRes.data.periodos)
//       ) {
//         periodosData = perRes.data.periodos;
//       }

//       setPeriodos(periodosData);

//       /* ===============================
//          PERIODO ACTIVO
//       =============================== */
//       if (activoRes.data) {
//         if (activoRes.data.periodo) {
//           setPeriodoActivo(activoRes.data.periodo);
//         } else {
//           setPeriodoActivo(activoRes.data);
//         }
//       } else {
//         setPeriodoActivo(null);
//       }

//     } catch (err) {
//       console.error("❌ INIT ERROR:", err);

//       setAsignaciones([]);
//       setPeriodos([]);
//       setPeriodoActivo(null);
//     }
//   };

//   init();

// }, [user, token, api]);

//   /* ================= REFRESH ================= */
//   useEffect(() => {
//     if (user) cargarContenidos();
//   }, [user, cargarContenidos]);

//   /* ================= SUBIR ================= */
//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!asignacionId || !titulo) {
//       return setMensaje({ texto: "❌ Completa los campos", tipo: "error" });
//     }

//     const fd = new FormData();
//     fd.append("titulo", titulo);
//     fd.append("descripcion", descripcion);
//     fd.append("tipo", tipo);
//     fd.append("asignacion_id", asignacionId);

//     if (periodoActivo?.id) {
//       fd.append("periodo_id", periodoActivo.id);
//     }

//     if (tipo === "archivo") {
//       if (!archivo) {
//         return setMensaje({ texto: "❌ Falta archivo", tipo: "error" });
//       }
//       fd.append("archivo", archivo);
//     } else {
//       if (!enlace) {
//         return setMensaje({ texto: "❌ Falta enlace", tipo: "error" });
//       }
//       fd.append("enlace", enlace);
//     }

//     try {
//       await api.post("/contenidos/subir", fd, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });

//       setMensaje({ texto: "✅ Contenido publicado", tipo: "success" });

//       setTitulo("");
//       setDescripcion("");
//       setArchivo(null);
//       setEnlace("");
//       setAsignacionId("");

//       cargarContenidos();
//     } catch (err) {
//       console.error(err);
//       setMensaje({ texto: "❌ Error al subir", tipo: "error" });
//     }
//   };

//   /* ================= DELETE ================= */
//   const eliminar = async (id) => {
//     if (!window.confirm("¿Eliminar contenido?")) return;

//     try {
//       await api.delete(`/contenidos/${id}`);
//       cargarContenidos();
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   return (
//     <div className="contenidos-container">

//       {/* ================= FORM ================= */}
//       <section className="seccion-subida">
//         <h2>📚 Contenidos Profesor</h2>

//         <form onSubmit={handleSubmit}>
//           <input
//             placeholder="Título"
//             value={titulo}
//             onChange={(e) => setTitulo(e.target.value)}
//           />

//           <textarea
//             placeholder="Descripción"
//             value={descripcion}
//             onChange={(e) => setDescripcion(e.target.value)}
//           />

//           <select
//             value={asignacionId}
//             onChange={(e) => setAsignacionId(e.target.value)}
//           >
//             <option value="">Seleccionar clase</option>
//             {(asignaciones || []).map((a) => (
//               <option key={a.asignacion_id} value={a.asignacion_id}>
//                 {a.grado}°{a.grupo} - {a.materia_nombre}
//               </option>
//             ))}
//           </select>

//           <select value={tipo} onChange={(e) => setTipo(e.target.value)}>
//             <option value="archivo">Archivo</option>
//             <option value="enlace">Enlace</option>
//           </select>

//           {tipo === "archivo" ? (
//             <input
//               type="file"
//               onChange={(e) => setArchivo(e.target.files[0])}
//             />
//           ) : (
//             <input
//               placeholder="URL"
//               value={enlace}
//               onChange={(e) => setEnlace(e.target.value)}
//             />
//           )}

//           <button type="submit">Publicar</button>
//         </form>

//         {mensaje.texto && <p>{mensaje.texto}</p>}
//       </section>

//       {/* ================= LISTA ================= */}
//       <section>
//         <h3>Mis contenidos</h3>

//         <select onChange={(e) => setPeriodoId(e.target.value)}>
//           <option value="">Todos los periodos</option>
//           {(periodos || []).map((p) => (
//             <option key={p.id} value={p.id}>
//               {p.nombre}
//             </option>
//           ))}
//         </select>

//         <table>
//           <thead>
//             <tr>
//               <th>Clase</th>
//               <th>Título</th>
//               <th>Tipo</th>
//               <th>Acción</th>
//             </tr>
//           </thead>

//           <tbody>
//             {(contenidos || []).length > 0 ? (
//               contenidos.map((c) => (
//                 <tr key={c.id}>
//                   <td>{c.grado}°{c.grupo}</td>
//                   <td>{c.titulo}</td>
//                   <td>{c.tipo}</td>
//                   <td>
//                     <button onClick={() => eliminar(c.id)}>🗑️</button>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="4">Sin contenidos</td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </section>
//     </div>
//   );
// }


//



import React, {
  useState,
  useEffect,
  useMemo,
  useCallback
} from "react";

import axios from "axios";

import { useAuth } from "../context/AuthContext";
import { API as BASE_API } from "../components/config";

import "../style/GestionContenido.css";

const API_URL = BASE_API;

export default function ContenidosProfesor() {

  const { user, token } = useAuth();

  /* =====================================================
      STATES
  ===================================================== */

  const [loading, setLoading] = useState(true);

  const [mensaje, setMensaje] = useState({
    texto: "",
    tipo: ""
  });

  const [asignaciones, setAsignaciones] = useState([]);
  const [contenidos, setContenidos] = useState([]);

  const [periodos, setPeriodos] = useState([]);
  const [periodoActivo, setPeriodoActivo] = useState(null);

  /* ---------- formulario ---------- */

  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");

  const [tipo, setTipo] = useState("archivo");

  const [enlace, setEnlace] = useState("");
  const [archivo, setArchivo] = useState(null);

  const [asignacionId, setAsignacionId] = useState("");

  const [periodoId, setPeriodoId] = useState("");

  /* =====================================================
      AXIOS
  ===================================================== */

  const api = useMemo(() => {

    return axios.create({

      baseURL: API_URL,

      withCredentials: true,

      headers: {
        Authorization: `Bearer ${token}`
      }

    });

  }, [token]);

  /* =====================================================
      CARGAR CONTENIDOS
  ===================================================== */

  const cargarContenidos = useCallback(async () => {

    try {

      const res = await api.get(
        "/contenidos/mis-contenidos",
        {
          params: {
            periodo_id: periodoId || undefined
          }
        }
      );

      let datos = [];

      if (Array.isArray(res.data)) {

        datos = res.data;

      } else if (
        res.data &&
        Array.isArray(res.data.contenidos)
      ) {

        datos = res.data.contenidos;

      }

      setContenidos(datos);

    } catch (error) {

      console.error("❌ Error cargando contenidos:", error);

      setContenidos([]);

    }

  }, [api, periodoId]);

  /* =====================================================
      CARGAR INFORMACIÓN INICIAL
  ===================================================== */

  useEffect(() => {

    if (!user || !token) return;

    const cargar = async () => {

      setLoading(true);

      try {

        const [

          asignacionesRes,
          periodosRes,
          periodoActivoRes

        ] = await Promise.all([

          api.get(
            `/contenidos/asignaciones-profesor/${user.id}`
          ),

          api.get("/contenidos/periodos"),

          api.get("/contenidos/periodo-activo")

        ]);

        /* ======================================
            ASIGNACIONES
        ====================================== */

        let asignacionesData = [];

        if (
          Array.isArray(asignacionesRes.data)
        ) {

          asignacionesData = asignacionesRes.data;

        } else if (
          asignacionesRes.data &&
          Array.isArray(
            asignacionesRes.data.asignaciones
          )
        ) {

          asignacionesData =
            asignacionesRes.data.asignaciones;

        }

        setAsignaciones(asignacionesData);

        /* ======================================
            PERIODOS
        ====================================== */

        let periodosData = [];

        if (
          Array.isArray(periodosRes.data)
        ) {

          periodosData = periodosRes.data;

        } else if (
          periodosRes.data &&
          Array.isArray(periodosRes.data.periodos)
        ) {

          periodosData =
            periodosRes.data.periodos;

        }

        setPeriodos(periodosData);

        /* ======================================
            PERIODO ACTIVO
        ====================================== */

        if (
          periodoActivoRes.data &&
          periodoActivoRes.data.id
        ) {

          setPeriodoActivo(periodoActivoRes.data);

        } else if (
          periodoActivoRes.data &&
          periodoActivoRes.data.periodo
        ) {

          setPeriodoActivo(
            periodoActivoRes.data.periodo
          );

        } else {

          setPeriodoActivo(null);

        }

      } catch (error) {

        console.error(
          "❌ Error inicial:",
          error
        );

        setAsignaciones([]);
        setPeriodos([]);
        setPeriodoActivo(null);

      } finally {

        setLoading(false);

      }

    };

    cargar();

  }, [user, token, api]);

  /* =====================================================
      RECARGAR CONTENIDOS
  ===================================================== */

  useEffect(() => {

    if (!user) return;

    cargarContenidos();

  }, [
    user,
    cargarContenidos
  ]);

    /* =====================================================
      LIMPIAR FORMULARIO
  ===================================================== */

  const limpiarFormulario = () => {

    setTitulo("");
    setDescripcion("");

    setTipo("archivo");

    setEnlace("");

    setArchivo(null);

    setAsignacionId("");

    const input = document.getElementById("archivoInput");

    if (input) {
      input.value = "";
    }

  };

  /* =====================================================
      SUBIR CONTENIDO
  ===================================================== */

  const handleSubmit = async (e) => {

    e.preventDefault();

    setMensaje({
      texto: "",
      tipo: ""
    });

    if (!asignacionId) {

      return setMensaje({
        texto: "Seleccione una asignación.",
        tipo: "error"
      });

    }

    if (!titulo.trim()) {

      return setMensaje({
        texto: "Ingrese un título.",
        tipo: "error"
      });

    }

    if (tipo === "archivo" && !archivo) {

      return setMensaje({
        texto: "Seleccione un archivo.",
        tipo: "error"
      });

    }

    if (tipo === "enlace" && !enlace.trim()) {

      return setMensaje({
        texto: "Ingrese un enlace.",
        tipo: "error"
      });

    }

    try {

      const formData = new FormData();

      formData.append(
        "asignacion_id",
        asignacionId
      );

      formData.append(
        "titulo",
        titulo.trim()
      );

      formData.append(
        "descripcion",
        descripcion.trim()
      );

      formData.append(
        "tipo",
        tipo
      );

      if (tipo === "archivo") {

        formData.append(
          "archivo",
          archivo
        );

      } else {

        formData.append(
          "enlace",
          enlace.trim()
        );

      }

      const res = await api.post(

        "/contenidos/subir",

        formData,

        {

          headers: {
            "Content-Type":
              "multipart/form-data"
          }

        }

      );

      if (res.data?.ok) {

        setMensaje({

          texto:
            res.data.message ||
            "Contenido publicado correctamente.",

          tipo: "success"

        });

        limpiarFormulario();

        cargarContenidos();

      } else {

        setMensaje({

          texto:
            res.data?.message ||
            "No fue posible guardar.",

          tipo: "error"

        });

      }

    } catch (error) {

      console.error(error);

      setMensaje({

        texto:
          error.response?.data?.message ||
          "Error al subir el contenido.",

        tipo: "error"

      });

    }

  };

  /* =====================================================
      ELIMINAR CONTENIDO
  ===================================================== */

  const eliminar = async (id) => {

    const ok = window.confirm(
      "¿Desea eliminar este contenido?"
    );

    if (!ok) return;

    try {

      await api.delete(
        `/contenidos/${id}`
      );

      setMensaje({

        texto:
          "Contenido eliminado correctamente.",

        tipo: "success"

      });

      cargarContenidos();

    } catch (error) {

      console.error(error);

      setMensaje({

        texto:
          error.response?.data?.message ||
          "No fue posible eliminar.",

        tipo: "error"

      });

    }

  };

  /* =====================================================
      VISTA PREVIA DEL ARCHIVO
  ===================================================== */

  const renderPreview = () => {

    if (!archivo) return null;

    if (archivo.type.startsWith("image/")) {

      return (

        <div className="preview-box">

          <img

            src={URL.createObjectURL(archivo)}

            alt="preview"

            className="preview-image"

          />

        </div>

      );

    }

    if (
      archivo.type ===
      "application/pdf"
    ) {

      return (

        <div className="preview-file">

          📄 {archivo.name}

        </div>

      );

    }

    if (
      archivo.type.includes("word") ||
      archivo.type.includes("document")
    ) {

      return (

        <div className="preview-file">

          📝 {archivo.name}

        </div>

      );

    }

    if (
      archivo.type.includes("excel") ||
      archivo.type.includes("spreadsheet")
    ) {

      return (

        <div className="preview-file">

          📊 {archivo.name}

        </div>

      );

    }

    if (
      archivo.type.includes("presentation") ||
      archivo.type.includes("powerpoint")
    ) {

      return (

        <div className="preview-file">

          📽️ {archivo.name}

        </div>

      );

    }

    if (
      archivo.type.startsWith("video/")
    ) {

      return (

        <video
          controls
          width="260"
        >

          <source
            src={URL.createObjectURL(archivo)}
          />

        </video>

      );

    }

    if (
      archivo.type.startsWith("audio/")
    ) {

      return (

        <audio controls>

          <source
            src={URL.createObjectURL(archivo)}
          />

        </audio>

      );

    }

    if (
      archivo.type.includes("zip") ||
      archivo.type.includes("rar")
    ) {

      return (

        <div className="preview-file">

          🗜️ {archivo.name}

        </div>

      );

    }

    return (

      <div className="preview-file">

        📎 {archivo.name}

      </div>

    );

  };

    /* =====================================================
      RENDER
  ===================================================== */

  return (

    <div className="contenidos-container">

      {/* =====================================================
          CABECERA
      ===================================================== */}

      <div className="contenidos-header">

        <div>

          <h1>

            📚 Gestión de Contenidos

          </h1>

          <p>

            Publica guías, talleres, tareas, videos,
            enlaces, documentos y material de apoyo
            para tus estudiantes.

          </p>

        </div>

        <div className="header-info">

          {periodoActivo && (

            <span className="badge-periodo">

              📅 {periodoActivo.nombre}

            </span>

          )}

        </div>

      </div>

      {/* =====================================================
          MENSAJES
      ===================================================== */}

      {mensaje.texto && (

        <div
          className={`alerta ${mensaje.tipo}`}
        >

          {mensaje.texto}

        </div>

      )}

      {/* =====================================================
          LOADING
      ===================================================== */}

      {loading ? (

        <div className="loading-box">

          <div className="spinner"></div>

          <p>

            Cargando información...

          </p>

        </div>

      ) : (

        <>

          {/* =====================================================
              FORMULARIO
          ===================================================== */}

          <section className="card card-formulario">

            <h2>

              📤 Publicar nuevo contenido

            </h2>

            <form
              onSubmit={handleSubmit}
              className="form-contenido"
            >

              {/* ===========================
                  ASIGNACIÓN
              =========================== */}

              <div className="form-group">

                <label>

                  Clase

                </label>

                <select

                  value={asignacionId}

                  onChange={(e) =>
                    setAsignacionId(
                      e.target.value
                    )
                  }

                >

                  <option value="">

                    Seleccione una clase

                  </option>

                  {(asignaciones || []).map((a) => (

                    <option

                      key={a.asignacion_id}

                      value={a.asignacion_id}

                    >

                      {a.grado}°
                      {a.grupo}
                      {" - "}
                      {a.materia_nombre}

                    </option>

                  ))}

                </select>

              </div>

              {/* ===========================
                  TÍTULO
              =========================== */}

              <div className="form-group">

                <label>

                  Título

                </label>

                <input

                  type="text"

                  value={titulo}

                  placeholder="Ej: Taller de Matemáticas"

                  onChange={(e) =>
                    setTitulo(
                      e.target.value
                    )
                  }

                />

              </div>

              {/* ===========================
                  DESCRIPCIÓN
              =========================== */}

              <div className="form-group">

                <label>

                  Descripción

                </label>

                <textarea

                  rows="4"

                  value={descripcion}

                  placeholder="Descripción del contenido..."

                  onChange={(e) =>
                    setDescripcion(
                      e.target.value
                    )
                  }

                />

              </div>

              {/* ===========================
                  TIPO
              =========================== */}

              <div className="form-group">

                <label>

                  Tipo de contenido

                </label>

                <select

                  value={tipo}

                  onChange={(e) =>
                    setTipo(
                      e.target.value
                    )
                  }

                >

                  <option value="archivo">

                    📄 Archivo

                  </option>

                  <option value="enlace">

                    🌐 Enlace

                  </option>

                </select>

              </div>
                            {/* ===========================
                  ARCHIVO
              =========================== */}

              {tipo === "archivo" && (

                <div className="form-group">

                  <label>

                    Archivo

                  </label>

                  <input

                    id="archivoInput"

                    type="file"

                    onChange={(e) =>

                      setArchivo(

                        e.target.files[0]

                      )

                    }

                  />

                  {renderPreview()}

                </div>

              )}

              {/* ===========================
                  ENLACE
              =========================== */}

              {tipo === "enlace" && (

                <div className="form-group">

                  <label>

                    URL

                  </label>

                  <input

                    type="url"

                    placeholder="https://..."

                    value={enlace}

                    onChange={(e) =>
                      setEnlace(
                        e.target.value
                      )
                    }

                  />

                </div>

              )}

              {/* ===========================
                  INFORMACIÓN DEL PERÍODO
              =========================== */}

              {periodoActivo && (

                <div className="info-periodo">

                  <strong>

                    📅 Período activo:

                  </strong>

                  {" "}

                  {periodoActivo.nombre}

                </div>

              )}

              {/* ===========================
                  BOTONES
              =========================== */}

              <div className="form-buttons">

                <button

                  type="submit"

                  className="btn-primary"

                >

                  📤 Publicar contenido

                </button>

                <button

                  type="button"

                  className="btn-secondary"

                  onClick={limpiarFormulario}

                >

                  🧹 Limpiar

                </button>

              </div>

            </form>

          </section>
                  {/* =====================================================
            MIS CONTENIDOS
        ===================================================== */}

        <section className="card card-listado">

          <div className="listado-header">

            <h2>

              📚 Mis contenidos publicados

            </h2>

            <div className="acciones-header">

              <select
                value={periodoId}
                onChange={(e) =>
                  setPeriodoId(e.target.value)
                }
              >

                <option value="">

                  Todos los períodos

                </option>

                {(periodos || []).map((p) => (

                  <option
                    key={p.id}
                    value={p.id}
                  >

                    {p.nombre}

                  </option>

                ))}

              </select>

              <button
                className="btn-primary"
                onClick={() =>
                  window.open(
                    `${API_URL}/contenidos/exportar/excel`,
                    "_blank"
                  )
                }
              >

                📥 Exportar Excel

              </button>

            </div>

          </div>

          <div className="tabla-responsive">

            <table className="tabla-contenidos">

              <thead>

                <tr>

                  <th>Clase</th>

                  <th>Materia</th>

                  <th>Título</th>

                  <th>Tipo</th>

                  <th>Archivo / Enlace</th>

                  <th>Fecha</th>

                  <th>Acciones</th>

                </tr>

              </thead>

              <tbody>

                {contenidos.length === 0 && (

                  <tr>

                    <td
                      colSpan="7"
                      className="sin-registros"
                    >

                      No existen contenidos publicados.

                    </td>

                  </tr>

                )}

                {contenidos.map((c) => (

                  <tr key={c.id}>

                    <td>

                      {c.grado}° {c.grupo}

                    </td>

                    <td>

                      {c.materia}

                    </td>

                    <td>

                      {c.titulo}

                    </td>

                    <td>

                      {c.tipo}

                    </td>

                    <td>

                      {c.archivo ? (

                        <>

                          {/\.(jpg|jpeg|png|gif|webp)$/i.test(c.archivo) && (

                            <img
                              src={c.archivo}
                              alt=""
                              className="mini-preview"
                            />

                          )}

                          <br />

                          <a
                            href={c.archivo}
                            target="_blank"
                            rel="noreferrer"
                          >

                            📄 Abrir archivo

                          </a>

                        </>

                      ) : c.enlace ? (

                        <a
                          href={c.enlace}
                          target="_blank"
                          rel="noreferrer"
                        >

                          🌐 Abrir enlace

                        </a>

                      ) : (

                        "-"

                      )}

                    </td>

                    <td>

                      {c.created_at
                        ? new Date(
                            c.created_at
                          ).toLocaleDateString()
                        : "-"}

                    </td>

                    <td>

                      <div className="acciones-tabla">

                        {c.archivo && (

                          <a
                            href={c.archivo}
                            target="_blank"
                            rel="noreferrer"
                            className="btn-ver"
                          >

                            👁 Ver

                          </a>

                        )}

                        <button
                          className="btn-editar"
                          onClick={() =>
                            alert(
                              "La edición se implementará en el siguiente paso."
                            )
                          }
                        >

                          ✏️ Editar

                        </button>

                        <button
                          className="btn-eliminar"
                          onClick={() =>
                            eliminar(c.id)
                          }
                        >

                          🗑 Eliminar

                        </button>

                      </div>

                    </td>

                  </tr>

                ))}

              </tbody>

            </table>

          </div>

        </section>
                {/* =====================================================
            MIS CONTENIDOS
        ===================================================== */}

        <section className="card card-listado">

          <div className="listado-header">

            <h2>📚 Mis contenidos publicados</h2>

            <div className="acciones-header">

              <select
                value={periodoId}
                onChange={(e) =>
                  setPeriodoId(e.target.value)
                }
              >
                <option value="">
                  Todos los períodos
                </option>

                {periodos.map((p) => (
                  <option
                    key={p.id}
                    value={p.id}
                  >
                    {p.nombre}
                  </option>
                ))}

              </select>

              <button
                type="button"
                className="btn-primary"
                onClick={() =>
                  window.open(
                    `${API_URL}/contenidos/exportar/excel`,
                    "_blank"
                  )
                }
              >
                📥 Exportar Excel
              </button>

            </div>

          </div>

          <div className="tabla-responsive">

            <table className="tabla-contenidos">

              <thead>

                <tr>

                  <th>Clase</th>
                  <th>Materia</th>
                  <th>Título</th>
                  <th>Tipo</th>
                  <th>Archivo / Enlace</th>
                  <th>Fecha</th>
                  <th>Acciones</th>

                </tr>

              </thead>

              <tbody>

                {contenidos.length === 0 ? (

                  <tr>

                    <td
                      colSpan="7"
                      className="sin-registros"
                    >
                      No existen contenidos publicados.
                    </td>

                  </tr>

                ) : (

                  contenidos.map((c) => (

                    <tr key={c.id}>

                      <td>
                        {c.grado}° {c.grupo}
                      </td>

                      <td>
                        {c.materia}
                      </td>

                      <td>
                        {c.titulo}
                      </td>

                      <td>
                        {c.tipo}
                      </td>

                      <td>

                        {c.archivo ? (

                          <>

                            {/\.(jpg|jpeg|png|gif|webp)$/i.test(c.archivo) && (

                              <img
                                src={`${API_URL}${c.archivo}`}
                                alt="preview"
                                className="mini-preview"
                              />

                            )}

                            <br />

                            <a
                              href={`${API_URL}${c.archivo}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              📄 Abrir archivo
                            </a>

                          </>

                        ) : c.enlace ? (

                          <a
                            href={c.enlace}
                            target="_blank"
                            rel="noreferrer"
                          >
                            🌐 Abrir enlace
                          </a>

                        ) : (

                          "-"

                        )}

                      </td>

                      <td>

                        {c.created_at
                          ? new Date(
                              c.created_at
                            ).toLocaleDateString("es-CO")
                          : "-"}

                      </td>

                      <td>

                        <div className="acciones-tabla">

                          {c.archivo && (

                            <a
                              href={`${API_URL}${c.archivo}`}
                              target="_blank"
                              rel="noreferrer"
                              className="btn-ver"
                            >
                              👁 Ver
                            </a>

                          )}

                          <button
                            type="button"
                            className="btn-eliminar"
                            onClick={() => eliminar(c.id)}
                          >
                            🗑 Eliminar
                          </button>

                        </div>

                      </td>

                    </tr>

                  ))

                )}

              </tbody>

            </table>

          </div>

        </section>
              </>

    )}

  </div>

);

}